import { render, staticRenderFns } from "./AiTranslate.vue?vue&type=template&id=bd612318&scoped=true"
import script from "./AiTranslate.vue?vue&type=script&lang=js"
export * from "./AiTranslate.vue?vue&type=script&lang=js"
import style0 from "./AiTranslate.vue?vue&type=style&index=0&id=bd612318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd612318",
  null
  
)

export default component.exports